import Constants from "../utils/consts";
import Cookies from "universal-cookie";

function getDbName() {
  try {
    return new Cookies().get("db", { path: "/" });
  } catch (error) {
    return undefined;
  }
}

const viewCompito = async (idCompito) => {
  return new Promise((resolve, reject) => {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const db = getDbName();

    // Usa il nuovo endpoint diretto (streaming, molto più veloce)
    const params = new URLSearchParams({
      uname: username,
      token: token,
      id: idCompito,
    });

    if (db) {
      params.append("db_name", db);
    }

    const url = `${
      Constants.mainUrl
    }getDownloadCompitiDirect.php?${params.toString()}`;

    // Apri direttamente in nuova tab (il browser gestisce il PDF)
    const newTab = window.open(url, "_blank");

    if (!newTab) {
      resolve({
        success: false,
        error: "Popup bloccato. Abilita i popup per visualizzare il file.",
      });
    } else {
      resolve({ success: true });
    }
  });
};

export default viewCompito;
